<template>
  <div
    class="flex flex-col landscape:flex-row landscape:gap-4 w-full h-screen overflow-y-hidden z-[1] landscape:p-6"
  >
    <!-- Sidebar Navigation (Landscape) -->
    <nav
      v-if="isLandscape"
      class="sidebar-nav w-auto landscape:max-w-[20rem] h-full overflow-hidden"
    >
      <NavigationLayout />
    </nav>

    <!-- Toggle Navigation (Portrait) -->
    <div v-if="!isLandscape" class="w-full z-20">
      <button
        @click="toggleSidebar"
        class="!absolute py-2 px-4 top-4 left-4 bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200"
      >
        <i
          class="fa-solid fa-bars text-[16px] font-bold text-gray-800 dark:text-gray-200"
        ></i>
      </button>
      <nav
        v-if="showSidebar"
        @click.self="showSidebar = false"
        class="mobile-sidebar fixed inset-0 bg-blue-gray-800 bg-opacity-60 z-50"
      >
        <div class="bg-white dark:bg-gray-800 h-full w-fit">
          <NavigationLayout @closePop="showSidebar = false" />
        </div>
        <button
          @click="toggleSidebar"
          class="!absolute top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-white transition-all hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <i class="fa-solid fa-xmark text-[16px]"></i>
          </span>
        </button>
      </nav>
    </div>

    <div class="flex-1 relative h-full flex flex-col">
      <!-- Header -->
      <ClientHeader />
      <div v-if="isMainAlert" class="pt-3 portrait:px-4 bg-transparent">
        <NotificationAlert @close="closeMainAlert" />
      </div>

      <div
        id="scrollable-content"
        class="flex-1 overflow-y-auto portrait:px-4 box-content portrait:!pr-3"
      >
        <!-- Main Content -->
        <main class="py-4">
          <router-view></router-view>
        </main>

        <HelpButton />
        <!-- Footer -->
        <footer
          class="footer p-4 flex flex-col justify-center items-center bg-white dark:bg-transparent border-t border-gray-200 dark:border-gray-700 rounded-xl"
        >
          <p class="text-gray-700 dark:text-gray-300">
            © {{ currentYear }} HiSell Technology
          </p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationLayout from "./navigationLayout.vue";
import ClientHeader from "./headerComponent.vue";
import NotificationAlert from "@/views/notificationAlert.vue";
import { useRoute } from "vue-router";
import { watch } from "vue";
export default {
  components: {
    NavigationLayout,
    ClientHeader,
    NotificationAlert,
  },
  data() {
    return {
      isLandscape: screen.orientation?.type?.startsWith("landscape") || false,
      showSidebar: false,
      isMainAlert: true,
      currentYear: new Date().getFullYear(),
    };
  },
  created() {
    this.$store.dispatch("isUseremailVerified");
  },
  mounted() {
    document.body.style.zoom = "100%";
    window.addEventListener("resize", this.checkOrientation);

    const route = useRoute();
    watch(
      () => route.path,
      () => {
        this.showSidebar = false;
      }
    );
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkOrientation);
  },
  methods: {
    closeMainAlert() {
      this.isMainAlert = false;
    },
    checkOrientation() {
      this.isLandscape = window.innerWidth > window.innerHeight;
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
};
</script>
